import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Funnel, Sparkles } from 'lucide-react';
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import JobListPanel from "./components/JobListPanel";
import { getJobPostList } from "../../../redux/jobpost/jobPostState";

const JobPosts = ({doSearch,recordList,filters}) => {

  useEffect(() => {
    if (filters) {
      doSearch(filters);
    }
  }, [filters, doSearch]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="relative gradient-effect ">
        <div className="group-hover:opacity-30 transition-opacity" />
        <div className="card-shadow"/>
        <div className="card-border-effect space-y-2">
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 flex items-center justify-center icon-effect gradient-primary">
              <Funnel className="w-5 h-5" />
            </span>
            <h2 className="text-gray-900 text-xl font-medium">Find Your Perfect Role</h2>
          </div>
          <div className="inline-flex gap-3 grid grid-cols-4">
            <SearchBar
              placeholder="Search jobs..."
            />
            <SelectOption
              placeholder="All Departments"
            />
            <SelectOption
              placeholder="All Locations"
            />
            <SelectOption
              placeholder="All Types"
            />
          </div>

          <div className="flex items-center gap-1">
            <Sparkles className="w-4 h-4 text-purple-600" />
            <span className="flex gap-1">
              Showing
				    <p className="font-semibold text-purple-600">{recordList.length}</p>
              positions
            </span>
          </div>
        </div>
      </div>
        <JobListPanel 
          jobs={recordList}
        />
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.jobPost.jobPostList?.items,
  filters: state.jobPost.jobPostList?.filters,
  requesting: state.jobPost.jobPostList?.requesting,
  error: state.jobPost.jobPostList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getJobPostList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobPosts);
